import LocaleContext, {
  ILocaleContext,
  LocaleConsumer,
  LocaleProps,
  LocaleProvider,
  withLocale,
} from "./Locale";

export {
  ILocaleContext,
  LocaleConsumer,
  LocaleProps,
  LocaleProvider,
  withLocale,
};
export default LocaleContext;
